import { render, staticRenderFns } from "./SubDistrictForm.vue?vue&type=template&id=8d93d616"
import script from "./SubDistrictForm.vue?vue&type=script&lang=js"
export * from "./SubDistrictForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports